import React, { MouseEvent } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";

import Icon from "../../imagery/Icon/Icon";
import Typography from "../../typography/Typography/Typography";
import { StyledChip } from "./Chip.styles";
import { ChipProps } from "./Chip.types";
import { SpaceOptionsOrZero } from "../../layout/Space/Space.types";

const Chip = ({
	iconName,
	label,
	className,
	onClick,
	onRemove,
	disabled,
	readOnly,
	...props
}: ChipProps) => {
	const block = new BemIt("Chip");
	const isButton = typeof onClick === "function";

	const handleRemoveClick = (e: MouseEvent<HTMLDivElement>) => {
		e.stopPropagation();
		if (onRemove) onRemove();
	};

	const handleClick = (e: React.MouseEvent<HTMLElement>) => {
		if (!disabled && !readOnly && isButton && typeof onClick === "function") {
			onClick(e);
		}
	};

	const resolveChipLabelMarginRight = (): SpaceOptionsOrZero => {
		return disabled || readOnly ? "0" : "xs";
	};

	return (
		<StyledChip
			className={addClass(className).after(block)}
			backgroundColor="bg_white"
			onClick={handleClick}
			htmlTag={isButton ? "button" : "div"}
			disabled={disabled}
			readOnly={readOnly}
			{...props}
		>
			{iconName && (
				<Icon
					className={block.el("icon").out}
					name={iconName}
					size="sm"
					color="dark_3"
					marginRight="xs"
				/>
			)}
			<Typography
				className={block.el("label").out}
				htmlTag="span"
				variant="body-small"
				color="fg_dark_3"
				weight="heaviest"
				marginRight={resolveChipLabelMarginRight()}
			>
				{label}
			</Typography>
			{!disabled && !readOnly && (
				<Icon
					className={block.el("remove-button").out}
					name="close"
					size="sm"
					htmlTag="button"
					onClick={handleRemoveClick}
				/>
			)}
		</StyledChip>
	);
};

export default Chip;
